import arrowDown from '../assets/icons/arrow-down.png';
import trendIcon from '../assets/icons/trend.svg';
import trendUpIcon from '../assets/icons/trend-up.svg';
import trendDownIcon from '../assets/icons/trend-down.svg';
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {mapRoutesEnToSv} from "../Utils/routes";

function Trend({value}: any) {
    let src = trendIcon
    if (value < -0.1) {
        src = trendDownIcon;
    } else if (value > 0.1) {
        src = trendUpIcon;
    } else if (value === null) {
        return <p className="text-center">-</p>;
    }

    return <img src={src} className="mx-auto" height="15" />
}

function Table({data, checkedItems = null, onItemClick, onSortChange, total, head}: any) {
    const [sort, setSort] = useState('count');
    const [isSortDesc, setIsSortDesc] = useState(true);

    const showTrends = !!data.filter((row: any) => row.trend !== undefined).length;

    function toggleCheckbox(e: any) {
        onItemClick(e.target.value);
    }

    function onClickSort(changedSort: string) {
        if (sort === changedSort) {
            setIsSortDesc(prev => !prev);
        } else {
            const sortDesc = changedSort !== 'name';
            setIsSortDesc(sortDesc);
        }

        setSort(changedSort);
    }

    useEffect(() => {
        onSortChange(sort, isSortDesc ? 'desc' : 'asc');
    }, [sort, isSortDesc]);

    if (checkedItems && !checkedItems.length) {
        return <></>;
    }

    return (
        <table className="table-auto border-collapse w-full">
            <thead>
                <tr className="sticky top-0 bg-grey-900">
                    {checkedItems && <th className="border-b border-grey-700 py-2 pe-2.5 w-5"></th>}
                    <th className="border-b border-grey-700 pt-4 pb-2 pe-3 font-body font-bold text-xs text-start">
                        <button className="flex flex-nowrap items-center" onClick={() => onClickSort('name')}>
                            {head}
                            {sort === 'name' && <img src={arrowDown} className={`rotate-${isSortDesc ? '0' : '180'}`} height="15" width="15" alt="Sort"/>}
                        </button>
                    </th>
                    {showTrends &&
                        <th className="border-b border-grey-700 pt-4 pb-2 pe-2.5 font-body font-bold text-xs w-16">
                            <button className="flex flex-nowrap items-center" onClick={() => onClickSort('trend')}>
                                Förändring
                                {sort === 'trend' && <img src={arrowDown} className={`rotate-${isSortDesc ? '0' : '180'}`} height="15" width="15" alt="Sort"/>}
                        </button>
                        </th>
                    }
                    <th className="border-b border-grey-700 pt-4 pb-2 font-body font-bold text-xs text-nowrap w-[70px] xl:w-28">
                        <button className="flex flex-nowrap items-center ml-auto" onClick={() => onClickSort('count')}>
                            <span>Jobb<wbr /><br className="sm:hidden"/>annonser</span>
                            { sort === 'count' && <img src={arrowDown} className={`rotate-${isSortDesc ? '0' : '180'}`} height="15" width="15" alt="Sort" />}
                        </button>
                    </th>
                    <th className="w-[8px] md:w-[20px]"></th>
                </tr>
            </thead>
            <tbody>
            {data.map((entry: any, index: number) => {
                const accent = checkedItems && checkedItems[index]?.color ? checkedItems[index]?.color : '';
                const entryName = entry.name.replaceAll(' ', ' <wbr>').replaceAll('/', '/<wbr>');
                return <tr key={entry.type + index} className="[&:last-child>td]:border-0">
                    {checkedItems && <td className="border-b border-grey-700 py-3 pe-2.5">
                                <input
                                    type="checkbox"
                                    value={entry.type}
                                    style={{accentColor: accent}}
                                    onChange={toggleCheckbox}
                                    checked={checkedItems[index]?.checked}
                                    disabled={!checkedItems[index].active}
                                />
                            </td>}
                            <td className="border-b border-grey-700 py-3 pe-3 font-body text-sm" lang="sv">
                                {entry.meta?._self
                                    ? <Link to={mapRoutesEnToSv(entry.meta._self)} className="underline" dangerouslySetInnerHTML={{__html: entryName}} />
                                    : <span dangerouslySetInnerHTML={{__html: entryName}} />
                                }
                            </td>
                            {showTrends && <td className="border-b border-grey-700 py-3 pe-2.5 font-body text-sm"><Trend value={entry.trend} /></td>}
                            <td className="border-b border-grey-700 py-3 font-body text-sm text-end">{entry.total.toLocaleString('sv')}</td>
                            <td></td>
                </tr>;
            })}
            </tbody>
        </table>
    );
}

export default Table;